import React from 'react';
import styles from './Card.module.css';

export default function Card({ children, className = '', elevation = 'default', ...rest }) {
  return (
    <div className={`${styles.card} ${styles[elevation]} ${className}`} {...rest}>
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ children, className = '', ...rest }) {
  return (
    <div className={`${styles.header} ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Title = function CardTitle({ children, className = '', as: As = 'h5', ...rest }) {
  return (
    <As className={`${styles.title} ${className}`} {...rest}>
      {children}
    </As>
  );
};

Card.Body = function CardBody({ children, className = '', ...rest }) {
  return (
    <div className={`${styles.body} ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Footer = function CardFooter({ children, className = '', ...rest }) {
  return (
    <div className={`${styles.footer} ${className}`} {...rest}>
      {children}
    </div>
  );
};
